import { useMemo } from 'react';

// returns the value when it's an array, otherwise an empty array. Centralizes
// the defensive "render nothing instead of crashing on bad shape" guard.
const useSafeArray = (value) => {
  return useMemo(() => (Array.isArray(value) ? value : []), [value]);
};

export default useSafeArray;
